import { Parameter } from '@shared/types';
import { Label } from '@/components/ui/label';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { LucideIcon } from 'lucide-react';

export function ParameterLabel({
  param,
  IconComponent,
  className = '',
}: {
  param: Parameter;
  IconComponent: LucideIcon;
  className?: string;
}) {
  const labelContent = (
    <Label
      className={`flex items-start gap-1.5 overflow-hidden text-ellipsis text-xs font-normal text-muted-foreground ${className}`}
      htmlFor={param.name}
    >
      <IconComponent className="h-3 w-3 flex-shrink-0" />
      <span>{param.displayName}</span>
    </Label>
  );

  if (param.tooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{labelContent}</TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          {param.tooltip}
        </TooltipContent>
      </Tooltip>
    );
  }

  return labelContent;
}
